export default __webpack_public_path__ + "static/media/01AW2MAY66.63efb772.jpg";